import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=186ee6ff&scoped=true&"
import script from "./OrdersView.vue?vue&type=script&lang=js&"
export * from "./OrdersView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=186ee6ff&scoped=true&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=186ee6ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ee6ff",
  null
  
)

export default component.exports